import React, { type JSX } from 'react';
import query from './EkonomiskAnalysUserSignaturesQuery.gql';
import {
  EkonomiskAnalysUserSignaturesQueryVariables,
  EkonomiskAnalysUserSignaturesQuery as EkonomiskAnalysUserSignaturesQueryData,
} from './_QueryTypes/EkonomiskAnalysUserSignaturesQuery';
import { useQuery, ApolloError } from '@apollo/client';

interface IProps {
  dbName: string;
  anvandsFor: string[];
  children: (Args: IChildrenArgs) => JSX.Element;
}

interface IChildrenArgs {
  loading: boolean;
  error?: ApolloError;
  users: IEkonomiskAnalysUser[];
}

interface IEkonomiskAnalysUser {
  name: string;
  id: string;
}

const EkonomiskAnalysUserSignaturesQuery: React.FC<IProps> = props => {
  const queryResult = useQuery<
    EkonomiskAnalysUserSignaturesQueryData,
    EkonomiskAnalysUserSignaturesQueryVariables
  >(query, {
    variables: { dbName: props.dbName, anvandsFor: props.anvandsFor },
  });

  return props.children({
    loading: queryResult.loading,
    error: queryResult.error,
    users:
      queryResult.data?.db?.SYSUser_All?.map(user => ({
        id: user.id,
        name: user.Fullname ?? 'Misslyckades att hämta namn',
      })) ?? [],
  });
};

export default EkonomiskAnalysUserSignaturesQuery;
